export default "__VITE_ASSET___T6WMoT0__"